// TODO: STANDARDIZE_SCAC_CODES
const autoscrapingSupportSCAC = [
    'MEDU', 'EGLV', 'ONEY', 'CMDU', 'APLU', 'PABV', 'COSU', 'HLCU',
];

export const billOfLadingMixin = {
    methods: {
        
    },
};